import Immutable, { type Map } from 'immutable';

import {
  GET_EMPLOYEES,
  GET_INVOICE_TEMPLATES,
  GET_MAIL_TEMPLATES,
} from '../actions/actions';

import type { LegacyAction } from '../middleware/api-middleware.types';

interface GlobalSettingsAction extends LegacyAction {
  data?: unknown;
}

type GlobalSettingsState = Map<string, unknown>;

function globalSettingsReducer(
  state: GlobalSettingsState = Immutable.fromJS({
    mailTemplates: [],
    invoiceTemplates: [],
    employees: [],
    employeesLoading: true,
  }),
  action: GlobalSettingsAction,
): GlobalSettingsState {
  switch (action.type) {
    case GET_MAIL_TEMPLATES: {
      return state.set('mailTemplates', Immutable.fromJS(action.data));
    }
    case GET_INVOICE_TEMPLATES: {
      return state.set('invoiceTemplates', Immutable.fromJS(action.data));
    }
    case `${GET_EMPLOYEES}_LOADING`: {
      return state.set('employeesLoading', true);
    }
    case GET_EMPLOYEES: {
      return state.merge({
        employees: Immutable.fromJS(action.data),
        employeesLoading: false,
      });
    }
    case `${GET_EMPLOYEES}_ERROR`: {
      return state.set('employeesLoading', false);
    }
    default: {
      return state;
    }
  }
}

export default globalSettingsReducer;
